import { render, staticRenderFns } from "./_query.vue?vue&type=template&id=262cca70"
import script from "./_query.vue?vue&type=script&lang=js"
export * from "./_query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IdSearch: require('/opt/app/components/Search.vue').default,IdNavigationSideLinks: require('/opt/app/components/navigation/SideLinks.vue').default,IdNavigationMobileNavButton: require('/opt/app/components/navigation/MobileNavButton.vue').default,IdSearchNrOfElements: require('/opt/app/components/search/NrOfElements.vue').default})
